/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadTaskWorkflowItem } from './LeadTaskWorkflowItem';
import {
    LeadTaskWorkflowItemFromJSON,
    LeadTaskWorkflowItemFromJSONTyped,
    LeadTaskWorkflowItemToJSON,
    LeadTaskWorkflowItemToJSONTyped,
} from './LeadTaskWorkflowItem';

/**
 * 
 * @export
 * @interface CreateLeadTaskWorkflowItem201Response
 */
export interface CreateLeadTaskWorkflowItem201Response {
    /**
     * 
     */
    data: LeadTaskWorkflowItem;
}

/**
 * Check if a given object implements the CreateLeadTaskWorkflowItem201Response interface.
 */
export function instanceOfCreateLeadTaskWorkflowItem201Response(value: object): value is CreateLeadTaskWorkflowItem201Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateLeadTaskWorkflowItem201ResponseFromJSON(json: any): CreateLeadTaskWorkflowItem201Response {
    return CreateLeadTaskWorkflowItem201ResponseFromJSONTyped(json, false);
}

export function CreateLeadTaskWorkflowItem201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadTaskWorkflowItem201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': LeadTaskWorkflowItemFromJSON(json['data']),
    };
}

export function CreateLeadTaskWorkflowItem201ResponseToJSON(json: any): CreateLeadTaskWorkflowItem201Response {
    return CreateLeadTaskWorkflowItem201ResponseToJSONTyped(json, false);
}

export function CreateLeadTaskWorkflowItem201ResponseToJSONTyped(value?: CreateLeadTaskWorkflowItem201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeadTaskWorkflowItemToJSON(value['data']),
    };
}

